import { lazy } from 'react'

export const DeliveryLazy = lazy(() => import('./Delivery'))
